// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'
import { authSuccessSchema } from './me'

export const verifyMfaRequestSchema = z.object({
  mfaToken: z.string(),
  code: z.string().length(6),
})
export type VerifyMfaRequest = z.infer<typeof verifyMfaRequestSchema>

/** Sucesso do verify-mfa = mesmo envelope de login direto (tokens + user + cookies httpOnly). */
export const verifyMfaResponseSchema = authSuccessSchema
export type VerifyMfaResponse = z.infer<typeof verifyMfaResponseSchema>
